import React, { useState, useEffect } from "react";
import "./FileLoadModal.scss";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import Spinner from "../UI/Spinner";
import RestClient from "../../../@core/restClient";

const FileLoadModal = ({
  closeFileLoadModal,
  songId,
  songTitle,
  mediaMessage
}: any) => {
  const [youtubeName, setYoutubeName] = useState("");
  const [youtube, setYoutube] = useState("");
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState<any>();
  const [fileOption, setFileOption] = useState("Вибрати");
  const [fileChoiceIsOpen, setFileChoiceIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [error, setError] = useState(false);

  // MANAGING MEDIA FILES CHOICE

  const openFileChoice = (e: any) => {
    e.stopPropagation();
    setFileChoiceIsOpen(true);
  };

  useEffect(() => {
    if (fileChoiceIsOpen) {
      document.body.addEventListener("click", () => {
        setFileChoiceIsOpen(false);
      });
    } else {
      return;
    }
  }, [fileChoiceIsOpen]);

  //DISABLE BTN TO LOAD
  useEffect(() => {
    if (!youtube || !youtubeName) {
      setBtnDisabled(true);
    } else {
      setBtnDisabled(false);
    }
  }, [youtube, youtubeName]);

  useEffect(() => {
    if (!file || !fileName) {
      setBtnDisabled(true);
    } else {
      setBtnDisabled(false);
    }
  }, [file, fileName]);

  // LOADING MEDIA FILES

  const handleFileLoading = async (e: any) => {
    setIsLoading(true); // Show spinner
    const file = e.target.files[0];
    if (!file) {
      setIsLoading(false);
      return;
    }

    // Simulate upload or processing delay
    await new Promise((resolve) => setTimeout(resolve, 1000));

    // Do your actual file handling logic here
    setFile(file);

    setIsLoading(false); // Hide spinner
  };

  const addFiles = () => {
    if (fileOption === "Посилання на YouTube") {
      const formData = new FormData();
      formData.append("songId", songId);
      formData.append("type", "YouTube");
      formData.append("name", youtubeName);
      formData.append("fileSrc", youtube);
      (async () => {
        try {
          setIsLoading(true);
          const response = await RestClient.addMedia(formData);
          if (response) {
            setIsLoading(false);
            closeFileLoadModal();
          }
        } catch (error) {
          setIsLoading(false);
          setError(true);
        }
      })();
    } else if (fileOption === "Завантажити файл") {
      let type = "";
      if (file.type.match("audio")) {
        type = "audio";
      } else if (file.type.match("image")) {
        type = "image";
      } else if (file.type.match("pdf")) {
        type = "pdf";
      } else if (file.type.match("powerpoint")) {
        type = "presentation";
      } else {
        type = "document";
      }
      const formDataFile = new FormData();
      formDataFile.append("songId", songId);
      formDataFile.append("type", type);
      formDataFile.append("name", fileName);
      formDataFile.append("file", file);

      (async () => {
        try {
          setIsLoading(true);
          const response = await RestClient.addMedia(formDataFile);
          if (response) {
            setIsLoading(false);
            closeFileLoadModal();
          }
        } catch (error) {
          setIsLoading(false);
          setError(true);
        }
      })();
    } else {
      return;
    }
  };

  return (
    <div className="files">
      {mediaMessage ? (
        <div className="files-inner">
          <div className="intro-statement">
            Щоб отримати право завантажувати медія ресурси, перейдіть, будь
            ласка, на більш розширений тарифний план. Це можна зробити у
            персональному кабінеті.
          </div>
          <div className="action-btns">
            <button
              className="btn-mcolor cancel-btn"
              onClick={closeFileLoadModal}
            >
              Ok
            </button>
          </div>
        </div>
      ) : (
        <div className="files-inner">
          {isLoading ? <Spinner /> : ""}

          <p className="intro-statement">
            Що ви хочете додати до пісні <span>{songTitle}</span> :
          </p>
          <div className="topic">
            <div className="topic-input-box">
              <input
                type="text"
                className="topic-field"
                value={fileOption}
                onChange={() => console.log("")}
                onClick={(e) => openFileChoice(e)}
              />
              {fileChoiceIsOpen ? <IoChevronUp /> : <IoChevronDown />}
            </div>
            {fileChoiceIsOpen ? (
              <div className="topic-options">
                <p
                  className="topic-options-item"
                  onClick={() => setFileOption("Посилання на YouTube")}
                >
                  Посилання на YouTube
                </p>
                <p
                  className="topic-options-item"
                  onClick={() => setFileOption("Завантажити файл")}
                >
                  Завантажити файл
                </p>
              </div>
            ) : (
              ""
            )}
          </div>
          {fileOption === "Посилання на YouTube" ? (
            <div className="input-box">
              <p className="file-type">YouTube video</p>
              <label htmlFor="VideoOne" className="label">
                Назва відео
              </label>
              <input
                type="text"
                name="VideoOne"
                id="VideoOne"
                className="youtube"
                onChange={(e) => setYoutubeName(e.target.value)}
              />
              <label htmlFor="Video" className="label">
                Посилання на відео в YouTube{" "}
                <span className="small">
                  (скоріюйте посилання в поле вводу)
                </span>{" "}
              </label>
              <input
                type="text"
                name="Video"
                id="Video"
                className="youtube"
                onChange={(e) => setYoutube(e.target.value)}
              />
            </div>
          ) : (
            ""
          )}
          {fileOption === "Завантажити файл" ? (
            <div className="input-box">
              <p className="file-type-warning">
                Увага! Розмір файлу не повинен перевищувати 5MB
              </p>
              <p className="label">
                <label htmlFor="Video" className="label">
                  Назва файлу для відображення
                </label>
                <input
                  type="text"
                  name="video"
                  id="Video"
                  className="youtube"
                  onChange={(e) => setFileName(e.target.value)}
                />
                <span className="small">
                  (Допустимі формати: аудіо - mp3, mid, midi; зображення - jpeg,
                  jpg, png; документи - pdf, docs, doc, docx, ppt, pptx, xls,)
                </span>
              </p>
              <label htmlFor="files" className="btn-mcolor file-label ">
                Виберіть файл...
              </label>
              <input
                type="file"
                id="files"
                className="file-input"
                onChange={(e) => handleFileLoading(e)}
                accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, audio/midi, audio/x-midi, audio/mpeg, image/jpeg,  image/png, application/pdf, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation,  application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              />
              <input
                type="text"
                className="file-file"
                readOnly
                value={file?.name}
              />
            </div>
          ) : (
            ""
          )}
          <div className="action-btns">
            {fileOption === "Завантажити файл" ||
            fileOption === "Посилання на YouTube" ? (
              <button
                className={
                  btnDisabled
                    ? "btn-mcolor-inactive btn-inactive"
                    : "btn-mcolor"
                }
                onClick={addFiles}
                disabled={btnDisabled}
              >
                Додати
              </button>
            ) : (
              ""
            )}
            <button
              className="btn-plain cancel-btn"
              onClick={closeFileLoadModal}
            >
              Скасувати
            </button>
          </div>
          {error ? (
            <div className="files-inner-error">
              <p>
                Файл не завантажився. Перевірте розмір, формат і спробуйте ще
                раз.
              </p>
              <button
                className="btn-mcolor"
                onClick={() => {
                  setError(false);
                  closeFileLoadModal();
                }}
              >
                Ok
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
      )}
    </div>
  );
};

export default FileLoadModal;
